import React from 'react'
import Avatar from 'srcReact/components/common2/Avatar'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

export default function MemberImages({
  imgSizeSingle,
  imgSizeDouble,
  imgSizeMore,
  members,
  onClick,
  handleOpenPopin,
  displayCount,
  conversationName,
  imgSingleCss,
  imgDoubleCss,
  imgMoreCss,
  from = ''
}) {
  const remainingCount = members.length - displayCount
  const { t } = useTranslation()
  return members.length === 1 ? (
    <Avatar
      userStatus={members[0].status}
      containerCSS={`${styles.oneImage} ${imgSingleCss}`}
      imgWrapperSize={imgSizeSingle}
      userId={members[0].id}
      profilePicture={members[0].profile_picture_url}
      firstname={members[0].firstname}
      lastname={members[0].lastname}
      showImageAsDecorative={true}
      onClickAction={
        from === 'quick-messenger' && handleOpenPopin
          ? () => handleOpenPopin()
          : onClick
          ? () => onClick(members[0])
          : null
      }
      mimeType={members[0].mime_type}
      originalTag={members[0].original_tag}
      isOriginal={members[0].is_original}
      withExpertiseGroup={members[0].with_expertise_group}
      ariaLabel={t('messenger.unNamedChatWith', {
        users: `${members[0].firstname} ${members[0].lastname}`
      })}
    />
  ) : members.length === 2 ? (
    <div
      tabIndex={0}
      onClick={(from === 'sidebar' || from === 'quick-messenger') && handleOpenPopin ? () => handleOpenPopin() : null}
      role='button'
      className={`${styles.twoImages} ${imgDoubleCss}`}
      aria-label={
        conversationName
          ? t('messenger.namedChatWith', { conversationName })
          : t('messenger.unNamedChatWith', {
              users: `${members[0].firstname} ${members[0].lastname} ${t('global.and')} ${members[1].firstname} ${
                members[1].lastname
              }`
            })
      }>
      {members.map((member, index) => {
        return (
          <Avatar
            userStatus={member.status}
            showImageAsDecorative={true}
            key={`${member.id}_${index}`}
            containerCSS={displayCount > 2 ? styles[`image${index + 1}Cross`] : styles[`image${index + 1}`]}
            imgWrapperSize={imgSizeDouble}
            userId={member.id}
            profilePicture={member.profile_picture_url}
            firstname={member.firstname}
            lastname={member.lastname}
            onClickAction={handleOpenPopin ? () => handleOpenPopin('manage-members') : null}
            mimeType={member.mime_type}
            originalTag={member.original_tag}
            isOriginal={member.is_original}
            withExpertiseGroup={members.with_expertise_group}
            ariaHidden={true}
          />
        )
      })}
    </div>
  ) : // </div>
  members.length === 3 ? (
    <div
      tabIndex={0}
      role='button'
      onClick={(from === 'sidebar' || from === 'quick-messenger') && handleOpenPopin ? () => handleOpenPopin() : null}
      className={`${styles.threeImages} ${imgMoreCss}`}
      aria-label={
        conversationName
          ? t('messenger.namedChatWith', { conversationName })
          : t('messenger.unNamedChatWith', {
              users: `${members[0].firstname} ${members[0].lastname}, ${members[1].firstname} ${
                members[1].lastname
              } ${t('global.and')} ${members[2].firstname} ${members[2].lastname}`
            })
      }>
      {members.map((member, index) => {
        return (
          <Avatar
            userStatus={member.status}
            showImageAsDecorative={true}
            key={`${member.id}_${index}`}
            containerCSS={styles[`image${index + 1}`]}
            imgWrapperSize={imgSizeMore}
            userId={member.id}
            profilePicture={member.profile_picture_url}
            firstname={member.firstname}
            lastname={member.lastname}
            onClickAction={handleOpenPopin ? () => handleOpenPopin('manage-members') : null}
            mimeType={member.mime_type}
            originalTag={member.original_tag}
            isOriginal={member.is_original}
            withExpertiseGroup={members.with_expertise_group}
            ariaHidden={true}
          />
        )
      })}
    </div>
  ) : displayCount > 2 ? (
    <div
      tabIndex={0}
      role='button'
      onClick={(from === 'sidebar' || from === 'quick-messenger') && handleOpenPopin ? () => handleOpenPopin() : null}
      className={`${styles.fourImages}  ${imgMoreCss}`}
      aria-label={
        conversationName
          ? t('messenger.namedChatWith', { conversationName })
          : t('messenger.unNamedChatWithMore', {
              users: `${members[0].firstname} ${members[0].lastname}, ${members[1].firstname} ${members[1].lastname}, ${members[2].firstname} ${members[2].lastname}`,
              n: remainingCount
            })
      }>
      {members
        .filter((member, index) => index <= displayCount)
        .map((member, index) => {
          if (index === 3) {
            return (
              <div
                key={`${member.id}_${index}`}
                onClick={handleOpenPopin ? () => handleOpenPopin('manage-members') : null}
                className={`${styles.remainingCountImage} ${styles['remainingCountImage' + imgSizeMore]}`}>
                {remainingCount}
              </div>
            )
          }
          return (
            <Avatar
              key={`${member.id}_${index}`}
              userStatus={member.status}
              showImageAsDecorative={true}
              containerCSS={styles[`image${index + 1}`]}
              imgWrapperSize={imgSizeMore}
              userId={member.id}
              profilePicture={member.profile_picture_url}
              firstname={member.firstname}
              lastname={member.lastname}
              onClickAction={handleOpenPopin ? () => handleOpenPopin('manage-members') : null}
              mimeType={member.mime_type}
              originalTag={member.original_tag}
              isOriginal={member.is_original}
              withExpertiseGroup={members.with_expertise_group}
              ariaHidden={true}
            />
          )
        })}
    </div>
  ) : (
    <div
      role='button'
      tabIndex={0}
      onClick={(from === 'sidebar' || from === 'quick-messenger') && handleOpenPopin ? () => handleOpenPopin() : null}
      className={`${styles.threeImages} ${imgMoreCss}`}
      aria-label={
        conversationName
          ? t('messenger.namedChatWith', { conversationName })
          : t('messenger.unNamedChatWithMore', {
              users: `${members[0].firstname} ${members[0].lastname}, ${members[1].firstname} ${members[1].lastname}, ${members[2].firstname} ${members[2].lastname}`,
              n: remainingCount
            })
      }>
      {members
        .filter((member, index) => index <= displayCount)
        .map((member, index) => {
          if (index === 2) {
            return (
              <div
                key={`${member.id}_${index}`}
                onClick={handleOpenPopin ? () => handleOpenPopin('manage-members') : null}
                className={`${styles.remainingCountImage} ${styles['remainingCountImage' + imgSizeMore]}`}>
                {remainingCount}
              </div>
            )
          }
          return (
            <Avatar
              userStatus={member.status}
              containerCSS={styles[`image${index + 1}`]}
              imgWrapperSize={imgSizeMore}
              userId={member.id}
              profilePicture={member.profile_picture_url}
              firstname={member.firstname}
              lastname={member.lastname}
              showImageAsDecorative={true}
              onClickAction={handleOpenPopin ? () => handleOpenPopin('manage-members') : null}
              mimeType={member.mime_type}
              originalTag={member.original_tag}
              isOriginal={member.is_original}
              withExpertiseGroup={members.with_expertise_group}
              ariaHidden={true}
            />
          )
        })}
    </div>
  )
}
